module.exports = __webpack_public_path__ + "img/gather-tab.b6fff7e3.png";